import { Navbar } from "../../components/Navbar";
import { Footer } from "../../components/Footer";
import { ChickenSightingsList } from "../../components/ChickenSightingsList";
import { Pagination } from "../../components/Pagination";
import { Chicken } from "../../types/Chicken";
import { Head } from '@inertiajs/react';

export default function Index({ chickens, images, pages, current_page, url_slug, user_id }: { chickens: Chicken[], images: object, pages: integer, current_page: integer, url_slug: string, user_id: integer }) {
  return (
    <>
      <Head title="Rooster Vision - View latest sightings" />
      <Navbar />
      <div className="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">
        <div className="container relative mx-auto">
          <div className="items-center flex flex-wrap">
            <div className="w-full px-4 ml-auto mr-auto text-center">
              <div>
                <h1 className="text-black font-semibold text-5xl mb-10">Latest Rooster Sightings</h1>
                <div className="w-full px-4 mb-10">
                  <div className="container font-bold text-4xl text-blue-500">
                    <ChickenSightingsList chickens={chickens} images={images} user_id={user_id} />
                  </div>
                </div>
                <Pagination pages={pages} current_page={current_page} url_slug={url_slug} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
